module.exports = __webpack_public_path__ + "img/ander1.21ac8c17.jpg";